<div class="modal-header">
    <h5 class="modal-title">{{lessonTitle}} bekijken</h5>
    <div>
        <a (click)="close()" title="Annuleren" class="btn btn-transparent mr-2">Sluiten</a>
    </div>
</div>
<div class="modal-body p-5">
    <ng-container>
        <form class="hidden" id="NameInputForm" [action]="portfolioPDFUrl">
            <input type="hidden" name="portfolioItemIds" [value]="portfolioId">
        </form>
        <div class="loader text-center" *ngIf="loading">
            <i class="fa-solid fa-spinner"></i>
        </div>
        <iframe id="portfolioPDF" type="application/pdf">
        </iframe>
    </ng-container>
</div>
<div class="modal-footer">
    <button class="btn" (click)="printPDF()"><span>Afdrukken</span></button>
    <button class="btn btn-success mr-2" (click)="downloadPDF()"><span>Downloaden</span></button>
</div>